import React from 'react';

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import PeopleIcon from '@material-ui/icons/PeopleOutline';

import classes from '../../css/getCSS';

const familyInfo = (props) => {
  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => props.editProfileSection('familyinfo')}>Edit</Button>
    );
  }

  let familyContact = null;
  if ( props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted) {
    familyContact = (
      <React.Fragment>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Father contact no.</p>
          <p className={classes.profileVal}>{props.profile.familyinfo.father_contact}</p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Mother contact no.</p>
          <p className={classes.profileVal}>{props.profile.familyinfo.mother_contact}</p>
          <br />
        </Grid>
      </React.Fragment>
    );
  }

  let familyLocation = null;
  if ( props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted) {
    familyLocation = (
      <React.Fragment>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Family residence city</p>
          <p className={classes.profileVal}>
            {props.profile.familyinfo.family_city
              ? props.profile.familyinfo.family_city.label : '-'}
          </p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Location</p>
          <p className={classes.profileVal}>{props.profile.familyinfo.location}</p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Type of Residence</p>
          <p className={classes.profileVal}>
            {props.profile.familyinfo.residence_type
              ? props.profile.familyinfo.residence_type.label : '-'}
          </p>
          <br />
        </Grid>
      </React.Fragment>
    );
  }

  

  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <PeopleIcon className={classes.titleIcon} />
          Family
        </Typography>
        <br />
        <Grid container>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Father Name</p>
            <p className={classes.profileVal}>{props.profile.familyinfo.father_name}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Mother Name</p>
            <p className={classes.profileVal}>{props.profile.familyinfo.mother_name}</p>
            <br />
          </Grid>
          {familyContact}
          {/*<Grid item md={6} sm={6} xs={12}>*/}
          {/*  <p className={classes.profileCap}>Father Occupation</p>*/}
          {/*  <p className={classes.profileVal}>*/}
          {/*    {props.profile.familyinfo.father_occupation*/}
          {/*      ? props.profile.familyinfo.father_occupation.label : '-'}*/}
          {/*  </p>*/}
          {/*  <br />*/}
          {/*</Grid>*/}
          {/*<Grid item md={6} sm={6} xs={12}>*/}
          {/*  <p className={classes.profileCap}>Mother Occupation</p>*/}
          {/*  <p className={classes.profileVal}>*/}
          {/*    {props.profile.familyinfo.mother_occupation*/}
          {/*      ? props.profile.familyinfo.mother_occupation.label : '-'}*/}
          {/*  </p>*/}
          {/*  <br />*/}
          {/*</Grid>*/}
          {familyLocation}
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Native Place</p>
            <p className={classes.profileVal}>{props.profile.familyinfo.native_place}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Mosal (Surname)</p>
            <p className={classes.profileVal}>{props.profile.familyinfo.mosal}</p>
            <br />
          </Grid>
          {/* <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Nanaji</p>
            <p className={classes.profileVal}>{props.profile.familyinfo.nanaji}</p>
            <br />
          </Grid> */}
        </Grid>
        {/*<Grid container>*/}
        {/*  <Grid item md={6} sm={6} xs={12}>*/}
        {/*    <p className={classes.profileCap}>Brothers(ભાઈ)</p>*/}
        {/*    <p className={classes.profileVal}>*/}
        {/*      Total: {props.profile.familyinfo.brother_count},*/}
        {/*      Married: {props.profile.familyinfo.brother_married}*/}
        {/*    </p>*/}
        {/*    <br />*/}
        {/*  </Grid>*/}
        {/*  <Grid item md={6} sm={6} xs={12}>*/}
        {/*    <p className={classes.profileCap}>Sisters(બહેન)</p>*/}
        {/*    <p className={classes.profileVal}>*/}
        {/*      Total: {props.profile.familyinfo.sister_count},*/}
        {/*      Married: {props.profile.familyinfo.sister_married}*/}
        {/*    </p>*/}
        {/*    <br />*/}
        {/*  </Grid>*/}
        {/*</Grid>*/}
      </Paper>
    </React.Fragment>
  );
};


export default familyInfo;



// WEBPACK FOOTER //
// ./src/profile/components/FamilyInfo.js